import { truncate } from "lodash";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Icon } from "@circle-react/components/shared/Icon";
import { CircularProgress } from "@circle-react/components/shared/uikit/TipTap/AttachmentPreviews/CircularProgress";
import {
  ATTACHMENT_STATUS_COMPLETED,
  ATTACHMENT_STATUS_UPLOADING,
} from "../../constants";

// import "./styles.css";

interface Attachment {
  blobUrl?: string;
  filename: string;
  progress?: number;
  status:
    | typeof ATTACHMENT_STATUS_COMPLETED
    | typeof ATTACHMENT_STATUS_UPLOADING;
  url: string;
  zendeskUploadId?: string;
}

interface FormAttachmentProps {
  attachment: Attachment;
  onCancel: (url: string) => void;
}

export const FormAttachment = ({
  attachment,
  onCancel,
}: FormAttachmentProps) => {
  const handleCancel = () => {
    onCancel(attachment.url);
  };

  return (
    <div className="bg-primary border-primary flex items-center justify-between gap-2 break-all rounded-2xl border px-4 py-2">
      <div className="flex items-center gap-2">
        {attachment.status === ATTACHMENT_STATUS_UPLOADING ? (
          <CircularProgress
            percentage={attachment.progress || 0}
            size={20}
            strokeWidth={2}
          />
        ) : (
          <Icon type="hw-paperclip" size={20} className="text-tertiary" />
        )}
        {attachment.status === ATTACHMENT_STATUS_COMPLETED ? (
          <a
            href={attachment.blobUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography.LabelXs weight="medium" color="text-darkest flex">
              {truncate(attachment.filename, { length: 32 })}
            </Typography.LabelXs>
          </a>
        ) : (
          <Typography.LabelXs weight="medium" color="text-darkest flex">
            {truncate(attachment.filename, { length: 34 })}
          </Typography.LabelXs>
        )}
      </div>
      <div className="flex items-center justify-between gap-2">
        {attachment.status === ATTACHMENT_STATUS_UPLOADING ? (
          <Typography.LabelXs weight="semibold" color="text-disabled">
            {Math.round(attachment.progress || 0)}%
          </Typography.LabelXs>
        ) : (
          <Icon
            type="16-close"
            size={16}
            onClick={handleCancel}
            className="text-dark cursor-pointer"
          />
        )}
      </div>
    </div>
  );
};
